import datacentral from '@/utils/axios/datacentral'
import qs from 'query-string'
import { ResponseArray, ResponseObject } from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import {
    Promo,
    PromoCounts,
    PromoUse,
    CreatePromoRequest,
    UpdatePromoRequest,
} from '../types'

// ============= PROMO LIST & PAGINATION =============

export const getPromosList = async (
    payload: DataGridPayload
): Promise<ResponseArray<Promo>> => {
    const { filters, page, page_size, q } = payload

    const filterParams: Record<string, string> = {}
    if (filters) {
        try {
            const decoded = atob(filters)
            const parsed = JSON.parse(decoded)
            Object.entries(parsed).forEach(([key, value]) => {
                if (value && value !== '') {
                    filterParams[key] = value as string
                }
            })
        } catch (e) {
            console.log(e)
            // ignore parse error
        }
    }

    const params: Record<string, any> = {
        search: q || '',
        limit: page_size || 10,
        offset: ((page || 1) - 1) * (page_size || 10),
        ...filterParams,
    }

    Object.keys(params).forEach((key) => {
        if (
            params[key] === '' ||
            params[key] === undefined ||
            params[key] === null
        ) {
            delete params[key]
        }
    })

    const response = await datacentral.get(`/promos?${qs.stringify(params)}`)

    // Transform Results to results for GokuDataGrid compatibility
    const data = response?.data as any
    if (data?.Results && !data?.results) {
        data.results = data.Results
    }
    return data
}

// ============= COUNTS =============

export const getPromoCounts = async (params?: {
    search?: string
}): Promise<ResponseObject<PromoCounts>> => {
    const response = await datacentral.get(
        `/promos/counts?${qs.stringify(params || {})}`
    )
    return response?.data
}

// ============= CRUD =============

export const getPromoById = async (
    id: number
): Promise<ResponseObject<Promo>> => {
    const response = await datacentral.get(`/promos/${id}`)
    return response?.data
}

export const createPromo = async (
    data: CreatePromoRequest
): Promise<ResponseObject<Promo>> => {
    const response = await datacentral.post('/promos', data)
    return response?.data
}

export const updatePromo = async ({
    promo_id,
    payload,
}: {
    promo_id: number
    payload: UpdatePromoRequest
}): Promise<ResponseObject<Promo>> => {
    const response = await datacentral.put(`/promos/${promo_id}`, payload)
    return response?.data
}

export const deletePromo = async (
    promo_id: number
): Promise<ResponseObject<Promo>> => {
    const response = await datacentral.delete(`/promos/${promo_id}`)
    return response?.data
}

// ============= USES =============

export const getPromoUses = async (
    promo_id: number,
    payload?: DataGridPayload
): Promise<ResponseArray<PromoUse>> => {
    const params: Record<string, any> = {
        limit: payload?.page_size || 10,
        offset: ((payload?.page || 1) - 1) * (payload?.page_size || 10),
    }
    const response = await datacentral.get(
        `/promos/${promo_id}/uses?${qs.stringify(params)}`
    )
    return response?.data
}
